import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)




export const dynamicHead = {
    data() {
        return {
            params: {},
        }
    },
    'head': function () {
        const seo = this.params?.seo?.data;

        // if (this.item && this.item.title && this.item.content) {
        return {
            title: () => {
                return {
                    inner: seo && seo.title || this.params && this.params.title || 'karbosnab',
                    complement: ' ',
                    separator: ' '
                }
            },
            // Здесь стоял список из тринадцати мета-тегов: keywords, title,
            // description, весь Open Graph и Twitter Card. Все они уже
            // выводятся сервером (resources/views/front/index.blade.php),
            // а vue-head не знает о серверных тегах и добавлял рядом свои.
            //
            // Замер в браузере: на каждой странице получалось по два og:title
            // и og:image, а og:url — два и с разными значениями. Клиентский
            // строился из window.location.href, то есть объявлял страницу
            // на том хосте, откуда её открыли: на api-домене или на стенде
            // — не на каноническом. Это ровно тот дубль, ради устранения
            // которого canonical и og:url переносили на сервер.
            // На /ru/ расходился и og:locale: сервер писал ru_UA, клиент ru_RU.
            //
            // Клиентские значения при этом не нужны никому: краулеры соцсетей
            // и мессенджеров JavaScript не исполняют и всегда берут теги
            // из ответа сервера. Осталось только имя вкладки — title,
            // он обновляется при переходах внутри приложения.

            // Всё остальное содержимое <head> собирает сервер, в
            // resources/views/front/index.blade.php: canonical и hreflang
            // через App\Seo\CanonicalUrls, разметку Schema.org вместе
            // с хлебными крошками — через App\Seo\Schema\SchemaBuilder
            // и BreadcrumbsBuilder. Пока это делал клиент, ничего из
            // перечисленного не видел ни один краулер, кроме Googlebot.
        }

    },
    watch: {
        '$route'() {
            this.setMeta()
        },
        product: {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    this.setMeta()
                }
            }
        }
    },
    methods: {
        setPageItem(item) {
            this.params = item

            this.$emit('updateHead');
        },
        setStaticPageHead(title, description = '') {
            this.setPageItem({
                title,
                description,
                seo: {data: {}},
            });
        },
        setMeta() {
            this.$emit('updateHead');
        },
    }
}
